<template>
  <el-dialog title='修改交车地' :visible.sync='deliveryVisible' @close='deliveryClose' center
             width='500px'>
    <div v-loading='deliveryLoading' class='p30 pb0'>
      <el-form :model='deliveryData' label-width='100px' :rules='deliveryRules'
               ref='deliveryForm'>
        <el-form-item label='交车区域：' prop='delivery'>
          <el-cascader size='mini'
                       class='w300'
                       v-model='deliveryData.delivery'
                       placeholder='请选择交车区域'
                       :options='positionOption2'
                       :props='props' ref='delivery' filterable
                       @change='handleChange2'
          />
        </el-form-item>
        <el-form-item label='交车港口：' prop='port'>
          <el-select v-model='deliveryData.port' class='w300' @change='endPortCh'
                     filterable clearable
                     size='mini' value-key='id' placeholder='请选择交车港口'>
            <el-option v-for='item in endPortList' :key='item.id' :label='item.supplier_name'
                       :value='item'></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <span slot='footer' class='dialog-footer'>
        <el-button size='mini' @click='deliveryClose'>取 消</el-button>
        <el-button size='mini' :loading='addLoad' type='primary'
                   @click='deliveryFinish'>确 定</el-button>
      </span>
  </el-dialog>
</template>

<script>
import { changeDelivery, getSelectPort } from '@/service/vehiclelog'

export default {
  name: 'carDelivery',
  data() {
    return {
      deliveryVisible: false,
      deliveryLoading: false,
      addLoad: false,
      deliveryData: {},
      deliveryRules: {
        delivery: {
          required: true,
          message: '请选择交车地',
          trigger: 'blur'
        }
      },
      positionOption2: [],
      endPortList: [],  // 交车港口
      props: {
        value: 'id',
        label: 'cityName',
        children: 'children'
      }
    }
  },
  methods: {
    openDialog(row) {
      this.deliveryVisible = true
      this.deliveryLoading = true
      if (row.deliveryId) this.getSelectPort(row.deliveryId)
      if (row.deliveryFullId.indexOf(',') != -1) {
        this.deliveryData.delivery = row.deliveryFullId.split(',')
      } else {
        this.deliveryData.delivery = row.deliveryFullId.split('/')
      }
      this.deliveryData.port = {
        id: row.deliveryPortId,
        supplier_name: row.deliveryPortName
      }
      this.deliveryData.id = row.id
      this.deliveryLoading = false
    },
    async getSelectPort(id) {
      const {
        status,
        message,
        data
      } = await getSelectPort(id)
      if (status !== 0) return this.$message.error(message)
      this.endPortList = data
    },
    // 修改交车地 -- 取消
    deliveryClose() {
      this.deliveryData = {}
      this.$refs.deliveryForm.resetFields()
      this.deliveryVisible = false
    },
    // 交车区域改变
    handleChange2(value) {
      if (value) {
        this.getSelectPort(value[value.length - 1], 2)
        this.deliveryData.port = ''
      }
    },
    // 修改交车地 -- 确认
    async deliveryFinish() {
      await this.$refs.deliveryForm.validate(async (valid) => {
        if (valid) {
          let end = this.$refs['delivery'].getCheckedNodes()
          let obj = {
            id: this.deliveryData.id,
            deliveryType: this.deliveryData.port ? 1 : 0,
            deliveryId: end[0].data.id,
            deliveryFullId: this.deliveryData.delivery.join(','),
            deliveryName: end[0].pathLabels.join('/'),
            deliveryCoordinate: end[0].data.center,
            deliveryPortId: this.deliveryData.port ? this.deliveryData.port.id : '',
            deliveryPortName: this.deliveryData.port ? this.deliveryData.port.supplier_name : ''
          }
          this.addLoad = true
          let res = await changeDelivery(obj)
          this.addLoad = false
          if (res.status !== 0) return this.$message.error(res.message)
          this.$message.success(res.message)
          this.deliveryVisible = false
          await this.$emit('getList')
        } else {
          return false
        }
      })
    },
    // 修改交车地 -- 交车港口改变
    endPortCh(val) {
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped>

</style>
